var _circle, _circle2, _ellipse, _path, _path2, _g, _path3, _path4, _ellipse2, _ellipse3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 103,
    r: 80,
    fill: "#00FFFF",
    opacity: 0.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 97,
    r: 80,
    fill: "#FF00FF",
    opacity: 0.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 100,
    rx: 80,
    ry: 80,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 98 C56 88 66 83 72 91 C78 83 88 88 88 98 C88 110 72 122 72 122 C72 122 56 110 56 98Z",
    fill: "#CC00CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 100 C59 90 69 85 75 93 C81 85 91 90 91 100 C91 112 75 124 75 124 C75 124 59 112 59 100Z",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(6 128 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114 100 C114 92 122 88 127 94 C132 88 140 92 140 100 C140 110 127 118 127 118 C127 118 114 110 114 100Z",
    fill: "#CC00CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 102 C117 94 125 90 130 96 C135 90 143 94 143 102 C143 112 130 120 130 120 C130 120 117 112 117 102Z",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72 152 Q100 166 132 154",
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74 154 Q102 168 134 156",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56,
    cy: 136,
    rx: 18,
    ry: 10,
    fill: "#FF69B4",
    opacity: 0.35
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146,
    cy: 132,
    rx: 12,
    ry: 8,
    fill: "#FF69B4",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.601d0f9a0dbbc7d5ad4420f4af1c61e5.svg";
export { ForwardRef as ReactComponent };